import { Flex, FlexItem, Box, Text } from '@bigcommerce/big-design';
import '../addressList.css';

export default function AddressBoxes({
	customer,
	isAddressSelected,
	setCustomerInformation,
}) {
	if (!Array.isArray(customer.addresses)) return null;

	return customer.addresses.map((address, index) => {
		const street1 = address?.address1 || address?.street_1 || '';
		const street2 = address?.address2 || address?.street_2 || '';

		return (
			<Box
				key={index}
				borderRadius="normal"
				backgroundColor="secondary20"
				border="box"
				display="inline-block"
				className="addressBox"
				marginBottom="medium"
			>
				<Flex
					alignContent="stretch"
					alignItems="stretch"
					flexDirection="row"
					justifyContent="flex-start"
					flexWrap="nowrap"
				>
					<FlexItem
						alignSelf="auto"
						flexBasis="auto"
						flexGrow={1}
						flexOrder={0}
						flexShrink={1}
					>
						<Flex
							flexDirection="column"
							padding="medium"
							margin="xxSmall"
							borderRadius="normal"
						>
							<FlexItem marginBottom="xxSmall">
								<Text bold>
									{address.first_name} {address.last_name}
								</Text>
							</FlexItem>
							<FlexItem flexGrow={1}>
								<Text marginBottom="xxSmall"> {street1}</Text>
								{street2 && (
									<Text marginBottom="xxSmall">
										{' '}
										{street2}
									</Text>
								)}
								{/* On the original address data with the customer, the "state" is called "country"*/}
								<Text>
									{address.city},{' '}
									{address.state || address.state_or_province}
									, {address.postal_code || address.zip}
								</Text>
							</FlexItem>
						</Flex>
					</FlexItem>
					<FlexItem marginTop="large" marginRight="large">
						<button
							className={
								isAddressSelected(address.id)
									? 'buttonAsLinkActive'
									: 'buttonAsLink'
							}
							onClick={() => {
								setCustomerInformation(
									'shipping_address',
									address,
								); // shipping_address is the address that is used to store the current customer address
							}}
						>
							{isAddressSelected(address.id)
								? 'Using this address'
								: 'Use this address'}
						</button>
					</FlexItem>
				</Flex>
			</Box>
		);
	});
}
